import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  keywordsContainer: {
    marginTop: theme.spacing(6)
  }
}));
